import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import DermaRangeSlider from "../Components/DermaRangeSlider";
import "./Theme.css";
import "./ReportFlareUp.css";

const TRIGGERS = [
  "reportFlareUp.triggers.dryWeather",
  "reportFlareUp.triggers.temperatureChange",
  "reportFlareUp.triggers.substances",
  "reportFlareUp.triggers.stress",
  "reportFlareUp.triggers.clothing",
  "reportFlareUp.triggers.allergens",
  "reportFlareUp.triggers.scratching",
  "reportFlareUp.triggers.foodAllergy",
  "reportFlareUp.triggers.insectBite",
  "reportFlareUp.triggers.infection",
  "reportFlareUp.triggers.sweating",
  "reportFlareUp.triggers.other",
];

const ReportFlareUp = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const uuid = urlParams.get("uuid") || "";
  const goqiiUserId = getGoqiiUserId();
  const nonce = urlParams.get("nonce") || "";
  const apiKey = urlParams.get("apiKey") || "";
  const signature = urlParams.get("signature") || "";
  const goqiiAccessToken = urlParams.get("goqiiAccessToken") || "";
  const authToken = urlParams.get("authToken") || "";
  const uid = urlParams.get("uid") || "";

  const [sliderValue, setSliderValue] = useState(0);
  const [selected, setSelected] = useState([]);
  const [otherText, setOtherText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  const toggleTrigger = (key) => {
    setSelected((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const isOtherSelected = selected.includes("reportFlareUp.triggers.other");

  const canLog =
    sliderValue > 0 && (!isOtherSelected || otherText.trim() !== "");

  const buildQs = () =>
    `uuid=${uuid}&uid=${uid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}&authToken=${authToken}&theme=${theme}&lang=${lang}`;

  const handleLog = () => {
    if (!canLog || submitting) return;
    setSubmitting(true);

    const resolvedParams = selected.map((k) =>
      k === "reportFlareUp.triggers.other" ? otherText.trim() : t(k)
    );

    lifestyleApi
      .logFlareUp({
        sliderValue,
        selectedParameters: JSON.stringify(resolvedParams),
      })
      .then((res) => {
        if (String(res?.data?.code) === "200") {
          window.location.href = `/report-flare-stats?${buildQs()}`;
        }
      })
      .catch((err) => console.error("logFlareUp:", err))
      .finally(() => setSubmitting(false));
  };

  return (
    <>
      <section className="rfu-page">
        <div className="rfu-container">
          <div className="rfu-question-block">
            <label className="rfu-label">{t("reportFlareUp.severityTitle")}</label>
            <DermaRangeSlider handleValue={setSliderValue} />
          </div>

          <div className="rfu-question-block">
            <label className="rfu-label">{t("reportFlareUp.triggersTitle")}</label>
            <div className="rfu-checkbox-list">
              {TRIGGERS.map((key) => (
                <label key={key} className="rfu-checkbox-item">
                  <input
                    type="checkbox"
                    checked={selected.includes(key)}
                    onChange={() => toggleTrigger(key)}
                  />
                  <span
                    className={`rfu-checkbox-box${selected.includes(key) ? " checked" : ""}`}
                  />
                  <span className="rfu-checkbox-label">{t(key)}</span>
                </label>
              ))}

              {isOtherSelected && (
                <input
                  className="rfu-other-input"
                  placeholder={t("reportFlareUp.otherPlaceholder")}
                  value={otherText}
                  onChange={(e) => setOtherText(e.target.value)}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="rfu-bottom-btn">
        <button
          type="button"
          className="rfu-btn-done"
          disabled={!canLog || submitting}
          onClick={handleLog}
        >
          {submitting ? t("reportFlareUp.logging", "Logging...") : t("reportFlareUp.logBtn")}
        </button>
      </section>
    </>
  );
};

export default ReportFlareUp;
